import { Injectable, inject } from '@angular/core';
import { ToastrType, URLS } from 'src/app/core/constants/ConstantVariables';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from '../generic/generic.service';
import { Observable, shareReplay, tap } from 'rxjs';
import { DropDownOptions } from 'src/app/models/DropDownOptions';
import { DBUser } from 'src/app/models/DBUser';

@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  private ToastrService = inject(ToastrService);
  private genericService = inject(GenericService);

  URLS: typeof URLS = URLS;
  Controller: string = '';

  constructor() {
    this.Controller = this.URLS.Controller.Common.Name;
  }

  GetIndustryList(searchValue: any) {
    return this.genericService
      .getData(
        this.Controller +
        this.URLS.Controller.Common.GetIndustryList +
        '/' +
        searchValue
      )
      .pipe(
        shareReplay(),
        tap(
          (data) => data,
          (error) => error
        )
      );
  }

  GetRelationshipList() {
    return this.genericService
      .getData(this.Controller + this.URLS.Controller.Common.GetRelationshipList)
      .pipe(
        shareReplay(),
        tap(
          (data) => data,
          (error) => error
        )
      );
  }

  getCityState(zipCode: any) {
    return this.genericService
      .getData(
        this.Controller +
        this.URLS.Controller.Common.GetCityStateList +
        '/' +
        zipCode
      )
      .pipe(
        shareReplay(),
        tap(
          (data) => data,
          (error) => error
        )
      );
  }

  getState() {
    return this.genericService
      .getData(this.Controller + this.URLS.Controller.Common.GetStateList)
      .pipe(
        shareReplay(),
        tap(
          (data) => data,
          (error) => error
        )
      );
  }

  getCountryList() {
    return this.genericService
      .getData(this.Controller + this.URLS.Controller.Common.GetCountryList)
      .pipe(
        shareReplay(),
        tap(
          (data) => data,
          (error) => error
        )
      );
  }

  GetSkillList() {
    return this.genericService
      .getData(this.Controller + this.URLS.Controller.Common.GetSkillList)
      .pipe(
        shareReplay(),
        tap(
          (data) => data,
          (error) => error
        )
      );
  }

  getCarrierList(searchText: string) {
    return this.genericService
      .getData(
        this.Controller +
        this.URLS.Controller.Common.GetCarrierList +
        '?searchText=' +
        searchText
      )
      .pipe(
        shareReplay(),
        tap(
          (data) => data,
          (error) => error
        )
      );
  }



  getPlantypeList(searchText: string) {
    return this.genericService
      .getData(
        this.Controller +
        this.URLS.Controller.Common.GetPlantypeList +
        '?searchText=' +
        searchText
      )
      .pipe(
        shareReplay(),
        tap(
          (data) => data,
          (error) => error
        )
      );
  }

  getAllDBUsers() {
    return this.genericService
      .getData(this.Controller + this.URLS.Controller.Common.GetDBUser)
      .pipe(
        shareReplay(),
        tap(
          (data) => data,
          (error) => error
        )
      );
  }

  getEthnicityList() {
    return this.genericService
      .getData(this.Controller + this.URLS.Controller.Common.GetEthnicityList)
      .pipe(
        shareReplay(),
        tap(
          (data) => data,
          (error) => error
        )
      );
  }

  GetLanguageList() {
    return this.genericService
      .getData(this.Controller + this.URLS.Controller.Common.GetLanguageList)
      .pipe(
        shareReplay(),
        tap(
          (data) => data,
          (error) => error
        )
      );
  }

  Toastr(type: ToastrType, message: string) {
    this.ToastrService.clear();
    if (
      message == null ||
      message == '' ||
      message.includes('User information is missing')
    ) {
      return false;
    }

    if (type == ToastrType.Success) {
      this.ToastrService.success(message);
    } else if (type == ToastrType.Warning) {
      this.ToastrService.warning(message);
    } else if (type == ToastrType.Info) {
      this.ToastrService.info(message);
    } else if (type == ToastrType.Error) {
      this.ToastrService.error(message);
    }

    return true;
  }

  getTimeDropDownOptions(): DropDownOptions[] {
    let timeRange: DropDownOptions[] = [
      { text: '12:00 AM', value: '12:00 AM' },
      { text: '01:00 AM', value: '01:00 AM' },
      { text: '02:00 AM', value: '02:00 AM' },
      { text: '03:00 AM', value: '03:00 AM' },
      { text: '04:00 AM', value: '04:00 AM' },
      { text: '05:00 AM', value: '05:00 AM' },
      { text: '06:00 AM', value: '06:00 AM' },
      { text: '07:00 AM', value: '07:00 AM' },
      { text: '08:00 AM', value: '08:00 AM' },
      { text: '09:00 AM', value: '09:00 AM' },
      { text: '10:00 AM', value: '10:00 AM' },
      { text: '11:00 AM', value: '11:00 AM' },
      { text: '12:00 PM', value: '12:00 PM' },
      { text: '01:00 PM', value: '01:00 PM' },
      { text: '02:00 PM', value: '02:00 PM' },
      { text: '03:00 PM', value: '03:00 PM' },
      { text: '04:00 PM', value: '04:00 PM' },
      { text: '05:00 PM', value: '05:00 PM' },
      { text: '06:00 PM', value: '06:00 PM' },
      { text: '07:00 PM', value: '07:00 PM' },
      { text: '08:00 PM', value: '08:00 PM' },
      { text: '09:00 PM', value: '09:00 PM' },
      { text: '10:00 PM', value: '10:00 PM' },
      { text: '11:00 PM', value: '11:00 PM' },
    ];

    return timeRange;
  }

  gettaxIdentifier() {
    return this.genericService
      .getData(this.Controller + this.URLS.Controller.Common.GetTaxIdentifier)
      .pipe(
        shareReplay(),
        tap(
          (data) => data,
          (error) => error
        )
      );
  }

  getTaxFillingStatus() {
    return this.genericService
      .getData(this.Controller + this.URLS.Controller.Common.GetTaxFilingStatus)
      .pipe(
        shareReplay(),
        tap(
          (data) => data,
          (error) => error
        )
      );
  }
  getTaxFillingStatusEmployee(taxName: any) {
    return this.genericService
      .getData(this.Controller + this.URLS.Controller.Common.GetTaxFilingStatus + '/' + taxName)
      .pipe(
        shareReplay(),
        tap(
          (data) => data,
          (error) => error
        )
      );
  }
  saveSateTaxSetting(data: any): Observable<any> {
    return this.genericService
      .postData(this.Controller + this.URLS.Controller.Common.SaveStateTax, data)
      .pipe(
        shareReplay(),
        tap(
          (data) => data,
          (error) => error
        )
      );
  }
  getEmployeeStateTax(data: any): Observable<any> {
    return this.genericService
      .postData(this.Controller + this.URLS.Controller.Common.GetStateTax, data)
      .pipe(
        shareReplay(),
        tap(
          (data) => data,
          (error) => error
        )
      );
  }
  // Send tax setting update using POST in bulk
  postTaxSettingDataBulk(employeeeGuid: string, data: any): Observable<any> {
    let url =
      this.URLS.Controller.EmployeeTaxSetting.Name +
      this.URLS.Controller.EmployeeTaxSetting.UpdateTaxSetting +
      `/${employeeeGuid}`;
    return this.genericService.postData(url, data).pipe(
      shareReplay(),
      tap(
        data => data,
        error => error
      )
    );
  }

  getTaxSetting(): Observable<any> {
    let url =
      this.URLS.Controller.EmployeeTaxSetting.Name +
      this.URLS.Controller.EmployeeTaxSetting.Get;
    return this.genericService.getData(url).pipe(
      shareReplay(),
      tap(
        data => data,
        error => error
      )
    );
  }
  getAlterTableColumnByUser(data: any): Observable<any> {
    return this.genericService
      .postData(
        this.Controller + this.URLS.Controller.Common.getAlterTableColumnByUser,
        data
      )
      .pipe(
        shareReplay(),
        tap(
          (data: any) => data,
          (error: any) => error
        )
      );
  }
  alterTableColumnByUser(data: any): Observable<any> {
    return this.genericService
      .postData(
        this.Controller + this.URLS.Controller.Common.alterTableColumnByUser,
        data
      )
      .pipe(
        shareReplay(),
        tap(
          (data: any) => data,
          (error: any) => error
        )
      );
  }
  getDecryptedSSN(encryptedSSN: any) {
    return this.genericService
      .getData(
        this.Controller + this.URLS.Controller.Common.GetDecryptSsn + '/' + encryptedSSN
      )
      .pipe(
        shareReplay(),
        tap(
          (data) => data,
          (error) => error
        )
      );
  }
}
